import { Button, Layout } from 'antd';
import { CornerUpLeft } from 'react-feather';
import Group from '../../Group';
import StatusTag from '../../StatusTag';
import SystemLogo from '../../SystemLogo';

interface Props {
  pageTitle: string;
  onBack: VoidFunction;
}

export default function WrapperLabelPrintingHeader({
  pageTitle,
  onBack,
}: Props) {
  return (
    <Layout.Header className="print-page-header">
      <Group align="center" position="between">
        <SystemLogo />

        <div className="print-page-header-title">
          <Group gap={16}>
            <span>
              Impressão de etiquetas | <strong>{pageTitle}</strong>
            </span>
            <StatusTag label="Versão de teste" color="yellow" />
          </Group>
        </div>

        <Button type="primary" ghost onClick={onBack}>
          <Group gap={10}>
            <CornerUpLeft size={16} style={{ margin: 0 }} />
            <span>Voltar</span>
          </Group>
        </Button>
      </Group>
    </Layout.Header>
  );
}
